<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tUC1OR/tc-custom/9780253008893.jpg?1726871162583" alt="This image is the cover for the book Ethnographic Encounters in Israel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ethnographic Encounters in Israel
      </h1>
      <p class="bookDescription body article font2">
        <b>Essays on the challenges of anthropological work in a complicated country: “A compelling anthology.” —Ruth Behar</b><br/><br/>Israel is a place of paradoxes, a small country with a diverse population and complicated social terrain. Studying its culture and social life means confronting a multitude of ethical dilemmas and methodological challenges.<br/><br/>These first-person accounts by anthropologists engage contradictions of religion, politics, identity, kinship, racialization, and globalization to reveal fascinating and often vexing dimensions of the Israeli experience. Caught up in pressing existential questions of war and peace, social justice, and national boundaries, the contributors explore the contours of Israeli society as insiders and outsiders, natives and strangers, as well as critics and friends.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fran Markowitz
      </h2>
      
      <p class="authorDescription body article"><P>Fran Markowitz is Professor in the Department of Sociology and Anthropology, Ben-Gurion University of the Negev. She is author of Sarajevo: A Bosnian Kaleidoscope and Coming of Age in Post-Soviet Russia and editor (with Michael Ashkenazi) of Sex, Sexuality and the Anthropologist and (with Anders H. Stefansson) of Homecomings: Unsettling Paths of Return.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d6ebb1c